import { SelectBot } from 'components/SelectBot';
import { Button } from 'components/shadcn/button';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarInset,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarProvider,
} from 'components/shadcn/sidebar';
import { Copy, Edit, MessageCircle } from 'lucide-react';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'sonner';

const DashboardLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const isActivePath = (path: string) => {
    return location.pathname.includes(path);
  };

  const navigationItems = [
    {
      path: 'conversations',
      label: 'Conversations',
      icon: MessageCircle,
      active: isActivePath('/conversations'),
    },
    {
      path: 'edit',
      label: 'Editor',
      icon: Edit,
      active: isActivePath('/edit'),
    },
  ];

  const handleCopyLink = () => {
    const link = `${window.location.origin}/${id}`;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        toast('Link copied to clipboard');
      })
      .catch((err) => {
        toast.error('Failed to copy link');
        console.error('Failed to copy: ', err);
      });
  };

  return (
    <>
      <header className="fixed top-0 left-0 w-full z-50 bg-background flex h-16 items-center gap-2 border-b px-4">
        <div className="flex w-full items-center justify-between">
          <SelectBot />
          <div className="flex items-center space-x-2">
            <Button variant="outline" size="sm" onClick={handleCopyLink}>
              <Copy className="h-4 w-4 mr-2" />
              Copy link to chat
            </Button>
            <Button
              size="sm"
              className="bg-green-500 hover:bg-green-600"
              onClick={() => navigate(`/${id}`)}
            >
              Chat with the bot
            </Button>
          </div>
        </div>
      </header>
      <SidebarProvider>
        {/* mt-16 for the header space */}
        <Sidebar className="mt-16">
          <SidebarContent>
            <SidebarGroup>
              <SidebarGroupContent>
                <SidebarMenu>
                  {navigationItems.map((item) => {
                    const Icon = item.icon;
                    return (
                      <SidebarMenuItem key={item.path}>
                        <SidebarMenuButton
                          disabled={!id}
                          onClick={() => navigate(`/${id}/${item.path}`)}
                          isActive={item.active}
                          size="lg"
                        >
                          <Icon className="h-4 w-4" />
                          <span>{item.label}</span>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    );
                  })}
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          </SidebarContent>
        </Sidebar>

        <SidebarInset>
          {/* Content */}
          {/* mt-16 for the header space */}
          <div className="mt-16">
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </>
  );
};

export default DashboardLayout;
